var map = {
	"./Logo-Desktop.svg": "./src/assets/images/logos/Logo-Desktop.svg",
	"./LogoLefebvre.png": "./src/assets/images/logos/LogoLefebvre.png",
	"./PagosCertificados.png": "./src/assets/images/logos/PagosCertificados.png",
	"./lefebvre-ij-143x50.png": "./src/assets/images/logos/lefebvre-ij-143x50.png",
	"./lefebvre-ij-bl-160x57.png": "./src/assets/images/logos/lefebvre-ij-bl-160x57.png",
	"./lefebvre-lexon-173x60.png": "./src/assets/images/logos/lefebvre-lexon-173x60.png",
	"./registro_impagados.svg": "./src/assets/images/logos/registro_impagados.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/logos sync recursive ^\\.\\/.*$";